export enum GoalType {
  Api = 'api',
  CustomVariable = 'custom_variable',
  Goal = 'goal',
  Sale = 'sales_tracker',
  Url = 'url',
}